// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"19":"richtext","736":"vendor"}[chunkId] || chunkId) + "." + {"19":"a9448582","136":"3d946b0f","147":"d2ecafff","219":"605da1ad","267":"0025e3a8","416":"c3a9c2c5","482":"7f09dba2","736":"0794fd41","840":"9d54bdc5","967":"cba68401"}[chunkId] + ".chunk.js";
};